import {
  RELATIVE_DATE_TYPE_PAST,
  DEFAULT_RELATIVE_DATE_OPTIONS,
  ALL_TIME,
} from 'components/Common/DateRangeFilter/constants';
import dayjs from 'services/dayjs';
import { ensureArray } from 'utils/arrays';
import { ensureObject } from 'utils/objects';

export const calculateDateTimeForRelativeDate = ({
  relativeDateId,
  relativeDateOptions = DEFAULT_RELATIVE_DATE_OPTIONS,
}) => {
  const { daysCount, relativeDateType } = ensureArray(relativeDateOptions).find(
    ({ id }) => relativeDateId === id,
  );

  if (relativeDateType === RELATIVE_DATE_TYPE_PAST) {
    return {
      // 1 day is subtracted from the daysCount because today is also selected
      startDate: dayjs().subtract(daysCount - 1, 'day'),
      endDate: dayjs(),
    };
  }

  // If relativeDateType is RELATIVE_DATE_TYPE_NEXT
  return {
    startDate: dayjs(),
    // 1 day is subtracted from the daysCount because today is also selected
    endDate: dayjs().add(daysCount - 1, 'day'),
  };
};

export const calculateRelativeDateFromDateTime = ({
  startDate,
  endDate,
  relativeDateOptions = DEFAULT_RELATIVE_DATE_OPTIONS,
}) => {
  // If no start and end date is passed, it will consider it as ALL_TIME option
  if (!startDate && !endDate) {
    return { id: ALL_TIME };
  }

  const dayDifference = dayjs(endDate).diff(startDate, 'days');

  return ensureObject(
    relativeDateOptions.find(
      ({ daysCount }) => daysCount - 1 === dayDifference,
    ),
  );
};

export const getSchoolYearToDateNumberOfDays = () => {
  const now = dayjs();
  const thisAugust = dayjs().month(7).date(1);
  const lastAugust = dayjs().subtract(1, 'year').month(7).date(1);

  // Use the August date that is most recent compared to the current date
  const augustDate = now.isAfter(thisAugust) ? thisAugust : lastAugust;

  // Add 1 to the difference to include the start date
  return now.diff(augustDate, 'days') + 1;
};
